import React from 'react';

import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';

export interface CustomStyles {
  name: string;
  styles: string;
  map?: string;
  next?: CustomStyles;
}
interface ButtonProps {
  customStyles?: CustomStyles;
  callback?: (e: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  id?: string;
  title?: string;
}
const ButtonStyle = styled.button`
  background-color: ${colors.Purple};
  border-radius: 6px;
  cursor: pointer;
  border: none;
  width: 100%;
`;

const Button: React.FC<ButtonProps> = ({
  customStyles,
  callback,
  children,
  disabled,
  id,
  title = ''
}) => {
  return (
    <ButtonStyle
      css={customStyles}
      onClick={callback}
      disabled={disabled}
      data-testid={id}
      title={title}>
      {children}
    </ButtonStyle>
  );
};

export default Button;
